var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"font-family":"Quicksand"},attrs:{"id":"app"}},[_c('menuTop'),_c('iconosWyC'),_c('router-view'),_c('redessociales')],1)}
var staticRenderFns = []

export { render, staticRenderFns }